import React, { useState, useEffect } from 'react';
import {
  PlainButton,
  FlexRow,
  DrawerHeader,
  PaddingWrapper,
} from 'components/styled-components';
import Select from 'react-select';
import { Drawer, Button, Icon, Intent } from '@blueprintjs/core';
import { AppToaster } from 'components/AppToaster';
import colors from 'utils/colors';
import styled from 'styled-components';
import customStyles from 'utils/select-styles';
import { DialogWrapper } from 'components/DialogWrapper';
import { mergeVendors } from 'api/vendors';

const MergeVendorsDrawer = ({
  allVendorsToMerge,
  handleFormSubmit,
  ...props
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [toKeep, setKeep] = useState();
  const [toMerge, setMerge] = useState();
  const [warningText, setWarningText] = useState();
  const [activeVendors, setActiveVendors] = useState([]);

  useEffect(() => {
    if (allVendorsToMerge.result)
      setActiveVendors(
        allVendorsToMerge.result.filter(v => v.status === 'Active')
      );
  }, [allVendorsToMerge]);

  const handleMergeVendors = () => {
    setDialogOpen(false);
    mergeVendors(toMerge.vendorID, toKeep.vendorID)
      .then(res => {
        AppToaster.show({
          message: res.data.message,
          intent: Intent.SUCCESS,
        });
        setIsOpen(false);
        setKeep('');
        setMerge('');
      })
      .catch(err => {
        AppToaster.show({
          message: err.response.data.message,
          intent: Intent.DANGER,
        });
      });
  };

  const handleOpenDialog = open => {
    const warning = `Are you sure you want to merge the Third Party "${
      toMerge.vendorName
    }" into "${toKeep.vendorName}"? This merge will archive "${
      toMerge.vendorName
    }" and cannot be undone once complete.`;
    setWarningText(warning);
    setDialogOpen(open);
  };

  return isOpen ? (
    <Drawer isOpen={isOpen} onClose={() => setIsOpen(false)}>
      <DrawerHeader>
        <span>Merge Third Parties</span>
        <div>
          <Button
            style={{ marginRight: '1rem', color: colors.blue }}
            minimal
            onClick={() => setIsOpen(false)}
          >
            CANCEL
          </Button>
          <PlainButton
            disabled={
              !toKeep || !toMerge || toKeep.vendorID === toMerge.vendorID
            }
            onClick={() => handleOpenDialog(true)}
          >
            Request Merge
          </PlainButton>
        </div>
      </DrawerHeader>
      <PaddingWrapper padding="0 2rem">
        <H2>Choose Third Parties to merge:</H2>
        <FlexRow justify="left">
          <span>
            <P>Third Party (to keep)</P>
            <Select
              value={toKeep}
              getOptionLabel={option => option.vendorName}
              getOptionValue={option => option.vendorID}
              options={activeVendors}
              onChange={setKeep}
              name="toKeep"
              styles={customStyles}
            />
          </span>
          <Icon
            icon="arrow-left"
            color={colors.gray}
            iconSize={16}
            style={{ margin: '2rem 0.5rem 0.5rem' }}
          />
          <span>
            <P>Third Party (to merge)</P>
            <Select
              value={toMerge}
              getOptionLabel={option => option.vendorName}
              getOptionValue={option => option.vendorID}
              options={activeVendors}
              onChange={setMerge}
              name="toMerge"
              styles={customStyles}
            />
          </span>
        </FlexRow>
      </PaddingWrapper>
      <DialogWrapper
        isOpen={dialogOpen}
        onClose={() => setDialogOpen(false)}
        title="Merge Vendor"
        body={warningText}
        confirm="MERGE"
        action={() => handleMergeVendors()}
      />
    </Drawer>
  ) : (
    <MergeButton
      onClick={() => {
        setIsOpen(true);
        props.updateVendorsList();
      }}
    >
      Merge Third Parties
    </MergeButton>
  );
};

const P = styled.p`
  font-size: 0.75rem;
  color: ${colors.gray};
  font-weight: 400;
`;

const H2 = styled.h2`
  color: ${colors.gray};
  font-size: 1rem;
`;

const MergeButton = styled.span`
  margin-right: 1rem;
  padding: 0.6875rem 1rem;
  background-color: ${colors.white};
  text-transform: uppercase;
  font-size: 0.875rem;
  color: ${colors.blue};
  border: 1px solid ${colors.lightestGray};
  border-radius: 5px;
  cursor: pointer;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  transition: all 0.3s;
  &:hover {
    background-color: ${colors.lightestGray};
  }
`;

export default MergeVendorsDrawer;
